<template>
  <v-layout wrap>
    <v-chip-group>
      <v-chip
      color="secondary"
      :small="$vuetify.breakpoint.lgAndDown"
      close @click:close="removeFilterItem(chip.key, chip.id)"
      v-for="chip in filterChips"
      :key="chip.key.concat(chip.id ?? '')">
        <span class="white--text">
          <v-icon small class="mr-1" :color="getColorForIcon(chip.icon)">{{ chip.icon }}</v-icon>
          {{(chip.text)}}
        </span>
      </v-chip>
    </v-chip-group>
  </v-layout>
</template>

<script>
import IconHelpers from '@/utils/IconHelpers'

export default {
  name: 'ContractFilterChips',
  props: {
    filterChips: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    IconHelpers
  }),

  methods: {
    removeFilterItem (key, id) {
      this.$emit('remove-filter-item', { key, id })
    },

    getColorForIcon (icon) {
      switch (icon) {
        case 'mdi-cancel': return 'error'
        case 'mdi-home':
        case 'mdi-file':
        case 'mdi-account-group':
        case 'mdi-alpha-s-circle-outline':
        case 'mdi-alpha-p-circle-outline':
        case 'mdi-alpha-w-circle-outline':
        case 'mdi-alpha-h-circle-outline':return 'white'
        default: return this.IconHelpers.getColorForIcon(icon)
      }
    }
  }
}
</script>
